import React, { useEffect, useState } from "react";
import { verifyActivationOtp } from "../../Actions/UserActions";
import { Avatar, Box, Button, CircularProgress, Paper, Typography } from "@mui/material";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import { MuiOtpInput } from "mui-one-time-password-input";
import CustomSnackbar from "../../Sections/Common/snackBar";
import NetcluesBrandLogo from "../../../src/Assets/svg/favicon.svg";

const VerifyOtp = ({ token, onSuccess }) => {
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "error",
    });

    const handleCloseSnackbar = () => {
        setSnackbar((prev) => ({
            ...prev,
            open: false,
        }));
    };

    const verify = async () => {
        try {
            setLoading(true);
            const res = await verifyActivationOtp({
                token,
                otp,
            });

            if (res.data.status === 200) {
                onSuccess(res.data.token);
            } else {
                setOtp("");
                setSnackbar({
                    open: true,
                    message: res.data.message || "OTP verification failed.",
                    severity: "error",
                });
            }
        } catch (err) {
            setOtp("");
            setSnackbar({
                open: true,
                message:
                    err.response?.data?.message ||
                    "Failed to verify OTP. Please try again.",
                severity: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (otp.length === 6 && !loading) {
            verify();
        }
    }, [otp]);

    return (
        <>
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "linear-gradient(135deg,#eef4ff 0%,#ffffff 100%)",
                    p: 2,
                }}
            >
                <Paper
                    elevation={6}
                    sx={{
                        width: 450,
                        p: 5,
                        borderRadius: 4,
                        textAlign: "center",
                    }}
                >
                    <Box textAlign="center" mb={4}>
                        <img
                            src={NetcluesBrandLogo}
                            alt="Logo"
                            style={{ width: 170 }}
                        />
                    </Box>

                    <Avatar
                        sx={{
                            bgcolor: "#22419e",
                            width: 72,
                            height: 72,
                            mx: "auto",
                            mb: 2,
                        }}
                    >
                        <MarkEmailReadIcon sx={{ fontSize: 36 }} />
                    </Avatar>

                    <Typography
                        variant="h4"
                        fontWeight="700"
                        gutterBottom
                    >
                        Verify Your Email
                    </Typography>

                    <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ mb: 4 }}
                    >
                        Enter the 6-digit verification code sent to your email
                        address.
                    </Typography>

                    <MuiOtpInput
                        value={otp}
                        disabled={loading}
                        onChange={(value) => {
                            if (!loading) {
                                setOtp(value);
                            }
                        }}
                        length={6}
                        autoFocus
                        sx={{
                            justifyContent: "center",
                            gap: 1.5,

                            "& .MuiOutlinedInput-root": {
                                width: 55,
                                height: 60,
                                borderRadius: 2,
                                fontSize: "1.5rem",
                                fontWeight: 700,
                            },

                            "& .MuiOutlinedInput-input": {
                                textAlign: "center",
                                padding: 0,
                            },
                        }}
                    />
                    {loading && (
                        <Box
                            display="flex"
                            justifyContent="center"
                            mt={3}
                        >
                            <CircularProgress size={28} />
                        </Box>
                    )}
                </Paper>
            </Box>
            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={handleCloseSnackbar}
            />
        </>
    );
};

export default VerifyOtp;